export class FormFieldBase<T>{
    value: T;
    key: string;//it will be field's id received from api
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    multipleValues : Array<any>;
    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        multipleValues? : Array<any> 
    } = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.multipleValues = options.multipleValues || [];
    }
}
